export interface IMinimalMedewerker {
    id: string;
    streamId: string;
    fullName: string;
}

export class Medewerker implements IMinimalMedewerker {
    public static GetAllMedewerker(): Medewerker {
        return { id: "", streamId: "", voornaam: "Alle", achternaam: "Medewerkers", email: "", fullName: "Alle Medewerkers", fullNamePrefixed: "Alle Medewerkers", isActive: true };
    }

    public id: string;
    public streamId: string;
    public voornaam: string;
    public achternaam: string;
    public fullName: string;
    public fullNamePrefixed: string;
    public email: string;
    public isActive: boolean;

    // List of 20 colors for avatar backgrounds
    private static avatarColors: string[] = [
        "#FF5733", "#33FF57", "#3357FF", "#FF33A1", "#A133FF",
        "#33FFF5", "#F5FF33", "#FF8C33", "#33FF8C", "#8C33FF",
        "#FF3333", "#33FF33", "#3333FF", "#FF33FF", "#33FFFF",
        "#FFA533", "#33FFA5", "#A533FF", "#FF5733", "#57FF33"
    ];

    // Function to select a color based on the hash of the id
    public static getAvatarColor(fullName: string): string {
        const hash = this.hashString(fullName);
        const index = Math.abs(hash) % Medewerker.avatarColors.length;
        return Medewerker.avatarColors[index];
    }

    // Helper function to hash a string
    private static hashString(input: string): number {
        let hash = 0;
        for (let i = 0; i < input.length; i++) {
            const char = input.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash |= 0; // Convert to 32-bit integer
        }
        return hash;
    }

    public static expandMiniMedewerker(miniMedewerker: IMinimalMedewerker): Medewerker {
        return { id: miniMedewerker.id, streamId: miniMedewerker.streamId, voornaam: "", achternaam: "", email: "", fullName: miniMedewerker.fullName, fullNamePrefixed: miniMedewerker.fullName, isActive: false };
    }
}

export type Medewerkers = Medewerker[];

export default Medewerker;